<template>
  <div v-if="preloader === true">
    <template>
      <bubble-loader />
    </template>
  </div>
  <div class="users-view-container" v-else>
    <v-card
      height="64px"
      width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 98%;
        padding-top: 16px;
      "
    >
      <v-card-title class="ml-0 pl-0 d-flex align-center">
        <router-link to="/management-dashboard" class="breadcrumb-previous-text">
          Dashboard
        </router-link>
        <span >
          <v-icon class="breadcrumb-arrow mx-2">mdi-chevron-right</v-icon>
        </span>

        <p class="breadcrumb-text mb-0">{{ getChartHeader() }}</p>
        <span>
          <v-icon class="breadcrumb-arrow ml-2">mdi-chevron-down</v-icon>
        </span>
      </v-card-title>

      <UserNavMenu />
    </v-card>
    <div fluid class="pad pl-8 pr-4 table-header">
      <div class="d-flex justify-space-between header-card light-border mb-6">
        <div>
          <span class="label">Group</span>: <span class="value">{{ displayGroups }}</span>
        </div>
        <div>
        <span class="label">School:</span>
          <span class="value">
            {{ visibleSchools.join(", ") }}
            <v-tooltip bottom v-if="remainingCount > 0">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="value" style="cursor: pointer">
                +{{ remainingCount }} more
                </span>
              </template>
              <div class="value">
                 <div v-for="school in hiddenSchools" :key="school">{{ school }}</div>
              </div>
            </v-tooltip>
          </span>
        </div>
      </div>
      <div class="d-flex justify-space-between">
        <div>
          <span class="chartHeader">{{ getChartHeader() }}</span>
        </div>

        <div class="d-flex align-center">
          <v-card width="350px" class="elevation-0 transparent">
            <v-text-field
              solo
              label="Search here..."
              hide-details
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              class="search-bar border-button rounded-pill mx-3"
              dense
              clearable
            >
            </v-text-field>
          </v-card>

          <v-btn
            depressed
            outlined
            rounded
            @click="downloadData"
            class="btn outline-btn elevation-0 mx-3"
            :class="{ 'disabled-btn': disableEXport }"
            :disabled="disableEXport"
            ><v-icon>mdi-import mdi-rotate-90</v-icon>
          </v-btn>

          <v-btn
            @click="filterDialog = true"
            class="btn outline-btn elevation-0 pl-4 pr-6 d-flex flex-row justify-center align-center"
          >
            <span class="icon"><v-icon>mdi-tune</v-icon></span>
            <span v-if="filterCount > 0">Filter ({{ filterCount }})</span>
            <span v-else>Filter</span>
          </v-btn>
        </div>
      </div>
      <div
        class="header-card mt-2 light-border py-3"
        v-if="chartIndex == 0">
        <v-row>
          <v-col>
            <div style="display: flex; gap: 16px;">
              <div class="label">Screening Pass: <span class="px-4 value">{{ screeningPassCount }}</span></div>
               <div style="width: 1px; height: 24px; background-color: #ccc;"></div>
              <div class="label pl-2">Screening Fail: <span class="px-4 value" >{{ screeningFailCount }}</span></div>
            </div>
          </v-col>
          <v-col class="d-flex justify-end">
             <div style="display: flex; gap: 16px;">
              <div class="label">Mains Pass: <span class="px-4 value">{{ mainsPassCount }}</span></div>
               <div style="width: 1px; height: 24px; background-color: #ccc;"></div>
              <div class="label pl-2">Mains Fail: <span class="px-4 value">{{ mainsFailCount }}</span></div>
            </div>
          </v-col>
        </v-row>
        
      </div>
      <v-chip-group
        v-model="selectedStatus"
        mandatory
        filter
        column
      >
        <v-chip
          v-for="status in formattedStatuses"
          :key="status.key"
          :value="status.key"
          class="ma-2"
          outlined
          @click="changeChipStatus"
          :color="selectedStatus === status.key ? 'active-chip' : ''">
          <span v-if="status.label == 'All'">{{ status.label }} ({{ totalCount }})</span>
          <span v-else>{{ status.label }} ({{ status.count }})</span>
        </v-chip>
      </v-chip-group>
      <v-data-table
        fixed-header
        height="calc(100vh - 320px)"
        :loading="isLoading"
        v-model="selected"
        :headers="tableHeaders"
        :items="users"
        :single-select="singleSelect"
        item-key="userId"
        :options.sync="options"
        :server-items-length="count"
        header-props.sort-icon="$blank"
        hide-default-footer
        class="cursor usertable rounded-table">
        
        <template v-slot:loading>
          <bubble-loader />
        </template>
        
        <template v-slot:no-data>
          <div class="custom-no-data" style="height: 160px">
            <p>No Data Available</p>
          </div>
        </template>

        <!-- Custom header slot for individual columns -->
        <template v-for="header in tableHeaders" v-slot:[`header.${header.value}`]="{ header: h }" >
        <span :key="header.value" class="header-content multi-line-ellipsis cursor" :title="h.text" >
          {{ h.text }}
          <span
            v-if="h.sortable !== false && (h.value != 'actionByCandidate' && h.value != 'status')"
            class="sort-icon-wrapper"
            :title="`Sort by ${h.text}`" 
            
          >
            <!-- Unsorted state -->
            <img 
              v-if="options.sortBy[0] !== h.value" 
              :src="sortIcons.unsorted" 
              alt="sort" 
              class="sort-icon"
            />
            
            <!-- Ascending state -->
            <img 
              v-else-if="!options.sortDesc[0]" 
              :src="sortIcons.asc" 
              alt="sort ascending" 
              class="sort-icon"
            />
            
            <!-- Descending state -->
            <img 
              v-else 
              :src="sortIcons.desc" 
              alt="sort descending" 
              class="sort-icon"
            />
          </span>
        </span>
      </template>

        
        <template v-slot:[`item.fullName`]="{ item }">
          {{ item.fullName}}
        </template>
        <template v-slot:[`item.emailId`]="{ item }">
            <v-tooltip bottom >
              <template v-slot:activator="{ on, attrs }">
                <span class='multi-line-ellipsis cursor'  v-bind="attrs" v-on="on" @click="copyEmailId(item.emailId)">{{  item.emailId  }}</span>
              </template>
                <span> {{ item.emailId }}</span>
            </v-tooltip>
        </template>
          <template v-slot:[`item.school`]="{ item }">
            <v-tooltip bottom >
              <template v-slot:activator="{ on, attrs }">
                <span class='multi-line-ellipsis cursor'  v-bind="attrs" v-on="on">{{  item.school  }}</span>
              </template>
                <span> {{ item.school }}</span>
            </v-tooltip>
        </template>
          <template v-slot:[`item.jobRole`]="{ item }">
            <v-tooltip bottom >
              <template v-slot:activator="{ on, attrs }">
                <span class='multi-line-ellipsis cursor'  v-bind="attrs" v-on="on">{{  item.jobRole  }}</span>
              </template>
                <span> {{ item.jobRole }}</span>
            </v-tooltip>
        </template>
         
        <template v-slot:[`item.screeningTotal`]="{ item }">
          <div class="text-center">
            
            <span>{{ item.screeningTotal }}/10</span>
          </div>
        </template>
        
        <template v-slot:[`item.mainsTotal`]="{ item }">
          <div class="text-center">
            <span v-if="item.mainsStatus">{{ item.mainsTotal }}/10</span>
            <span v-else>NA</span>
          </div>
        </template>
        
        <template v-slot:[`item.hiringmanager`]="{ item }">
          <span v-if="item.hiringmanager">{{ item.hiringmanager }}</span>
          <span v-else>-</span>
        </template>
        
        <template v-slot:[`item.stage`]="{ item }">
          
            <span>{{ getStatusInfo(item.stage).label }}</span>
          
          
        </template>
        
        <template v-slot:[`item.actionByCandidate`]="{ item }">
          <div class="text-center">
          <v-chip
            :color="getStatusInfo(item.actionByCandidate).color"
            :text-color="getStatusInfo(item.actionByCandidate).textColor"
          >
            {{ getStatusInfo(item.actionByCandidate).label }}
          </v-chip>
          </div>
        </template>
        
        <template v-slot:[`item.status`]="{ item }">
          <div class="text-center">
            <v-chip
            :color="getStatusInfo(item.status).color"
            :text-color="getStatusInfo(item.status).textColor">
            {{ getStatusInfo(item.status).label }}
            </v-chip>
          </div>
          
        </template>
        <template v-slot:footer="{ props }">
          <table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update-options="onFooterUpdate"
          />
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
      <v-card
        width="570px"
        height="100vh"
        class="filterDialogClass d-flex flex-column"
      >
        <!-- Header - Fixed at top -->
        <v-row class="mt-4 mx-1 flex-shrink-0">
          <v-col>
            <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
              Filter
            </div>
          </v-col>
          <v-col class="d-flex justify-end">
            <div @click="clearFilter" class="clear-filter-btn">
              Clear Filter
            </div>
          </v-col>
        </v-row>

        <!-- Tabs Content - Scrollable -->
        <v-tabs vertical class="flex-grow-1" style="overflow: hidden">
          <div class="ml-3 mt-4 mr-4 filterLine">
            <v-tab class="black--text justify-start" active-class="activeTab">
              <div class="tab-content">
                <span>Group</span>
                <span v-if="selectedGroupFilter.length > 0">
                  <div class="status-count-badge">
                    <p>
                      {{ selectedGroupFilter.length }}
                    </p>
                  </div>
                </span>
              </div>
            </v-tab>

            <v-tab class="black--text justify-start" active-class="activeTab">
              <div class="tab-content">
                <span>School</span>
                <span v-if="selectedSchoolFilter.length > 0" class="ml-1"
                  ><div class="status-count-badge">
                    <p>{{ selectedSchoolFilter.length }}</p>
                  </div></span
                >
              </div>
            </v-tab>

            <v-tab class="black--text justify-start" active-class="activeTab">
              <div class="tab-content">
                <span>Preferred Job Role</span>
                <span v-if="selectedJobRoleFilter.length > 0" class="ml-1">
                  <div class="status-count-badge">
                    <p>{{ selectedJobRoleFilter.length }}</p>
                  </div>
                </span>
              </div>
            </v-tab>
            <v-tab
              class="black--text justify-start"
              active-class="activeTab"
              v-if="chartIndex == 4"
            >
              <div class="tab-content">
                <span>Stage</span>
                <span v-if="selectedStageFilter.length > 0" class="ml-1">
                  <div class="status-count-badge">
                    <p>{{ selectedStageFilter.length }}</p>
                  </div>
                </span>
              </div>
            </v-tab>
            <v-tab
              class="black--text justify-start"
              active-class="activeTab"
              v-if="chartIndex == 0"
            >
              <div class="tab-content">
                <span>Status</span>
                <span v-if="selectedStatusFilter.length > 0" class="ml-1">
                  <div class="status-count-badge">
                    <p>{{ selectedStatusFilter.length }}</p>
                  </div>
                </span>
              </div>
            </v-tab>
          </div>

          <v-tab-item>
            <v-card flat height="100%" class="d-flex flex-column">
              <v-card-text class="flex-shrink-0">
                <v-text-field
                  v-model="searchGroupTerm"
                  label="Search groups..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  class="px-4"
                />
              </v-card-text>
              <v-card-text
                class="flex-grow-1 pt-0 pb-16"
                style="overflow-y: auto; max-height: calc(100vh - 280px)"
              >
                <!-- "All" Chip (outside of chip group) -->
                <v-chip
                  class="mb-2"
                  :class="{ 'active-chip': isAllGroupSelected }"
                  @click="toggleAllGroupSelection"
                  elevated
                >
                  All
                </v-chip>

                <!-- Chip Group -->
                <v-chip-group
                  v-model="selectedGroupFilter"
                  multiple
                  column
                  active-class="active-chip"
                >
                  <v-chip
                    v-for="(item, index) in filteredGroupItems"
                    :key="index"
                    :value="item"
                    elevated
                  >
                    {{ item }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat height="100%" class="d-flex flex-column">
              <v-card-text class="flex-shrink-0">
                <v-text-field
                  v-model="searchSchoolTerm"
                  label="Search schools..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  class="px-4"
                />
              </v-card-text>
              <v-card-text
                class="flex-grow-1 pt-0 pb-16"
                style="overflow-y: auto; max-height: calc(100vh - 280px)"
              >
                <!-- "All" Chip (outside of chip group) -->
                <v-chip
                  class="mb-2"
                  :class="{ 'active-chip': isAllSelected }"
                  @click="toggleAllSelection"
                  elevated
                >
                  All
                </v-chip>

                <!-- Chip Group -->
                <v-chip-group multiple column>
                  <v-chip
                    v-for="(item, index) in filteredItems"
                    :key="index"
                    :value="item"
                    :class="{
                      'active-chip': selectedSchoolFilter.includes(item),
                    }"
                    @click="toggleSelectedSchools(item)"
                    elevated
                  >
                    {{ item }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat height="100%" class="d-flex flex-column">
              <v-card-text class="flex-shrink-0">
                <v-text-field
                  v-model="searchJobTerm"
                  label="Search job role..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  class="px-4"
                />
              </v-card-text>
              <v-card-text
                class="flex-grow-1 pt-0 pb-16"
                style="overflow-y: auto; max-height: calc(100vh - 280px)"
              >
                <!-- "All" Chip (outside of chip group) -->
                <v-chip
                  class="mb-2"
                  :class="{ 'active-chip': isAllJobSelected }"
                  @click="toggleAllJobsSelection"
                  elevated
                >
                  All
                </v-chip>

                <!-- Chip Group -->
                <v-chip-group
                  multiple
                  column
                  v-model="selectedJobRoleFilter"
                  active-class="active-chip"
                >
                  <v-chip
                    v-for="(item, index) in filteredJobItems"
                    :key="index"
                    :value="item"
                    elevated
                  >
                    {{ item }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item v-if="chartIndex == 4">
            <v-card
              flat
              height="100%"
              style="overflow-y: auto; max-height: calc(100vh - 200px)"
            >
              <v-card-text class="pb-16">
                <FilterSearch :items="stages" v-model="selectedStageFilter" />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item v-if="chartIndex == 0">
            <v-card
              flat
              height="100%"
              style="overflow-y: auto; max-height: calc(100vh - 200px)"
            >
              <v-card-text class="pb-16">
                <FilterSearch :items="results" v-model="selectedStatusFilter" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>

        <!-- Footer Buttons - Fixed at bottom -->
        <div class="filterDialogButton flex-shrink-0">
          <v-card-actions class="px-6 pb-3">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              depressed
              class="btn outline-btn font-weight-medium pa-4"
              @click="filterDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              class="btn primary-btn pa-4"
              @click="(filterDialog = false), (isApply = true), filterUsers()"
              >Apply</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="emailSnackbar" :timeout="1000">
        Email Id Copied
     </v-snackbar>
  </div>
</template>
<script>
import DashboardController from "@/controllers/DashboardController";
import UserNavMenu from "@/components/UserNavMenu.vue";
import BubbleLoader from "@/components/BubbleLoader.vue";
import SchoolController from "@/controllers/SchoolController";
import { debounce } from "lodash";
import Papa from "papaparse";
import FilterSearch from "@/components/FilterSearch.vue";
import SortUnsorted from '@/assets/Sort.svg';
import SortAsc from '@/assets/Sort.svg';
import SortDesc from '@/assets/Sort.svg';
export default {
  components: {
    BubbleLoader,
    UserNavMenu,
    FilterSearch
  },
  data() {
    return {
      sortIcons: {
        unsorted: SortUnsorted,
        asc: SortAsc,
        desc: SortDesc
      },
      isLoading: false,
      users: [],
      selected: [],
      singleSelect: false,
      count: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy:[]
      },
      preloader: false,
      statuses: ["All"],
      selectedStatus: "all", // Default selected
      filterDialog: false,
      filterCount: 0,
      search: "",
      groups: [],
      schools: [],
      chartIndex: null,
      selectedJobRoleFilter: [],
      selectedGroupFilter: [],
      selectedSchoolFilter: [],
      preferredJobRoles: [],
      filterUsersLoader: false,
      debouncedUserSearch: null,
      stages: ["Before Screening", "Before Mains", "Before Demo"],
      dashboardData: [],
      previousSchoolNames: [],
      previousGroupName: [],
      selectedStageFilter: [],
      results: ["Pass", "Fail"],
      selectedStatusFilter: [],
      schoolList: [],
      statusWiseCount: {},
      screeningPassCount:0,
      screeningFailCount:0,
      mainsPassCount:0,
      mainsFailCount:0,
      totalCount:0,
      searchTerm: '',
      searchGroupTerm: '',
      searchSchoolTerm: '',
      searchJobTerm: '',
      isApply:false,
      exportData:[],
      emailSnackbar: false,
      skipNextOptionWatch:false,
      disableEXport:false
    };
  },
  methods: {
    async onFooterUpdate(newOptions) {
      this.skipNextOptionWatch = true;
      Object.assign(this.options, newOptions);
      await this.$nextTick();
      this.viewDashboard();
    },
    copyEmailId(emailId){
    navigator.clipboard
      .writeText(emailId)
      .then(() => {
        this.emailSnackbar = true;
      })
    },
    changeSort(column) {
      if (this.options.sortBy[0] === column) {
        // Toggle sort direction
        this.options.sortDesc[0] = !this.options.sortDesc[0];
      } else {
        // Set new sort column
        this.options.sortBy = [column];
        this.options.sortDesc = [false];
      }
    },
    getSortIcon(column) {
      if (this.options.sortBy[0] !== column) {
        return 'mdi-unfold-more-horizontal'; // Default unsorted icon
      }
      return this.options.sortDesc[0] ? 'mdi-arrow-down' : 'mdi-arrow-up';
    },
    getSortIconClass(column) {
      return {
        'sort-icon': true,
        'active': this.options.sortBy[0] === column
      };
    },
    toggleAllSelection() {
      if (this.isAllSelected) {
        this.selectedSchoolFilter = [];
        
      } else {
        this.selectedSchoolFilter = [...this.filteredItems];
        
      }
    },
    toggleAllGroupSelection() {
      if (this.isAllGroupSelected) {
        this.selectedGroupFilter = [];
        
      } else {
        this.selectedGroupFilter = [...this.filteredGroupItems];
        
      }
    },
    toggleAllJobsSelection() {
      if (this.isAllJobSelected) {
        this.selectedJobRoleFilter = [];
        
      } else {
        this.selectedJobRoleFilter = [...this.filteredJobItems];
        
      }
    },
    getChartHeader() {
      switch (this.chartIndex) {
        case 0:
          return "Overall Performance";
        case 1:
          return "Interview Scheduling Status";
        case 2:
          return "Post Interview Progress";
        case 3:
          return "Interview To Offer Conversion Rate";
        case 4:
          return "Candidate Activity Status";
        case 5:
          return "Avg. Time to close Application";
        default:
          return ""; // or some default header
      }
    },
    async viewDashboard() {
      this.disableEXport = false;
      this.isLoading = true; // Start loading
      this.count = 0;
      this.users = [];

      try {        
        const statusList = this.getActualStatus(this.selectedStatus);

        // toBeScheduled can't be expressed as a single filters.latestStatus value - it
        // depends on each candidate's own numberOfRounds/currentTestRoundIndex (screening/
        // mains/demo are each optional per candidate), so the backend resolves it in JS
        // when it sees this sentinel field instead of matching a literal status.
        const field = this.selectedStatus === "toBeScheduled"
          ? "computed.pendingInterviewScheduling"
          : "filters.latestStatus";

        if(this.isApply == false || this.selectedSchoolFilter.length <= 0){
            this.schoolList.forEach((school) => {
            if (!this.selectedSchoolFilter.includes(school)) {
              this.selectedSchoolFilter.push(school);
            }
            });
        }
        if(this.isApply == false ||this.selectedGroupFilter.length <= 0){
            this.groups.forEach((group) => {
            if (!this.selectedGroupFilter.includes(group)) {
              this.selectedGroupFilter.push(group);
            }
            });
        }

        let sortOrder = "asc";
        let sortBy = "";  // default empty, if no sorting

        if (this.options.sortBy.length > 0) {
          sortBy = this.options.sortBy[0];  // first column to sort by
          sortOrder = this.options.sortDesc[0] ? "desc" : "asc";
        }
        const requestBody = {
          values: statusList,
          field: field,
          searchValue: this.search,
          groupFilter: this.selectedGroupFilter.includes('All') && this.selectedGroupFilter.length !== this.groups.length ? this.selectedGroupFilter.filter(v=>v != 'All') : this.selectedGroupFilter,
          schoolFilter: this.selectedSchoolFilter,
          jobRoleFilter: this.selectedJobRoleFilter,
          stageFilter: this.selectedStageFilter,
          statusFilter: this.selectedStatusFilter.includes('All') ? ['Pass','Fail'] : this.selectedStatusFilter,
          chartIndex: this.chartIndex,
          page: this.options.page,
          sortOrder: sortOrder,
          sortBy: sortBy, 
          itemsPerPage: this.options.itemsPerPage,
        };

        const response = await DashboardController.viewDashboard(requestBody);

        this.dashboardData = response.data;
        this.exportData = response.exportAudience;
        this.count = response.total;        
        if(this.exportData.length <= 0)
          this.disableEXport = true;
        
        console.log("response", response);
        this.preferredJobRoles = response.uniqueJobRoles;
        
        this.users = this.dashboardData.map((user) => ({
          userId: user.id,
          personalInfo: user.personalInfo,
          fullName: user.fullName,
          emailId: user.personalInfo.contactInfo.email,
          school: user.teachingInterests.schools,
          jobRole: user.teachingInterests?.jobRole?.HRIS_unique_role,
          status: user.filters.latestStatus,
          hiringmanager: user.hiringmanager,
          stage: user.stage,
          actionByCandidate: user.actionByCandidate,
          screeningTotal: user.screeningTotal,
          mainsTotal: user.mainsTotal,
          mainsStatus:user.mainsStatus,
          daysToCloseApplication: this.calculateDaysDifference(
            user.decisionGivenOn,
            user.finalInterviewCompletedOn
          ),
        }));
      } catch (error) {
        console.error("Error loading dashboard data:", error);
      } finally {
        this.isLoading = false; // Stop loading regardless of success or error
      }
    },
    getActualStage() {
      return this.selectedStageFilter;
    },
   
    getActualStatus(status) {
      const statusMap = {
        all: {
          0: ["All"],
          1: [
            "INTERVIEW SCHEDULED",
            "INTERVIEW RESCHEDULED",
            "DEMO SUBMITTED",
            "INTERVIEW COMPLETED",
            "NOTIFY_HR",
            "ROUND_ACCEPTED",
            "SEND_TO_HIRING_MANAGER", "ACCEPT", "REJECT", "ONHOLD"
          ],
          2: ["INTERVIEW SCHEDULED","INTERVIEW RESCHEDULED","INTERVIEW COMPLETED","SEND_TO_HIRING_MANAGER", "ACCEPT", "REJECT", "ONHOLD"],
          3: ["ACCEPT", "REJECT", "ONHOLD"],
          4: ["isNow", "isTakeLater", "isHREvaluate","noAction"],
          5: ["ACCEPT", "REJECT", "ONHOLD"],
        },
        pendingWithHiringManager: ["SEND_TO_HIRING_MANAGER"],
        toBeScheduled: ["DEMO SUBMITTED"],
        scheduled: ["INTERVIEW SCHEDULED",
            "INTERVIEW RESCHEDULED",
            "INTERVIEW COMPLETED",
            "NOTIFY_HR",
            "ROUND_ACCEPTED",
            "SEND_TO_HIRING_MANAGER", "ACCEPT", "REJECT", "ONHOLD"],
        decisionDoneByHiringManager: ["ACCEPT", "REJECT", "ONHOLD"],
        offered: ["ACCEPT"],
        notOffered: ["REJECT", "ONHOLD"],
        pendingWithHr: ["INTERVIEW COMPLETED"],
        pendingWithInterviewer:["INTERVIEW SCHEDULED","INTERVIEW RESCHEDULED"],
        nownotStarted: ["isNow"],
        later: ["isTakeLater"],
        hrToRevert: ["isHREvaluate"],
        noAction:["noAction"],
        accepted: ["ACCEPT"],
        rejected: ["REJECT"],
        onHold: ["ONHOLD"],
        screening: ["SCREENING PASSED",
          "SCREENING FAILED"],
        mains: [
          "MAINS PASSED",
          "MAINS FAILED",
        ],
      };
      const chartSpecific = statusMap[status];

      // ✅ If chart-specific mapping exists (e.g. All or Pending)
      if (typeof chartSpecific === "object" && !Array.isArray(chartSpecific)) {
        return chartSpecific[this.chartIndex] || chartSpecific.default || [];
      }

      // ✅ For simple one-level mappings
      return chartSpecific || [];
    },
    filterUsers() {
      this.skipNextOptionWatch = this.options.page !== 1;
      this.options.page = 1;
      this.getFilterCount();
      this.debouncedUserSearch();
      this.debouncedChartCountSearch();
      
      this.filterDialog = false;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth is zero-based
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year}  ${hours}:${minutes}`;
    },
    calculateDaysDifference(date1, date2) {
      if (!date1 || !date2) return "NA";
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      if (isNaN(d1) || isNaN(d2)) return "NA";

      const diffTime = d1 - d2; // milliseconds

      if (diffTime < 0) return "NA"; // avoid negative days

      const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

      return diffDays + " Days";
    },
    downloadData() {
      const fileName = this.getChartHeader();
      const csvData = this.exportData.map((item) => {
        const baseObj = {
          "Name of the Candidate":
            (item.personalInfo?.firstName || "") +
            " " +
            (item.personalInfo?.lastName || ""),
          "Email Id": item.personalInfo?.contactInfo?.email || "NA",
          "Preferred Location": item.teachingInterests?.schools || "NA",
          "Preferred Job Role":
            item.teachingInterests?.jobRole?.HRIS_unique_role || "NA",
        };
        if (this.chartIndex == 0) {
          if (this.selectedStatus === 'screening' || this.selectedStatus === 'all') {
            baseObj["Screening Status"] = item.screeningStatus || "NA";
            baseObj["Screening Net Score"] = item.screeningStatus ? item.screeningTotal : "NA";
        }

        if (this.selectedStatus === 'mains' || this.selectedStatus === 'all') {
          baseObj["Mains Status"] = item.mainsStatus || "NA";
          baseObj["Mains Net Score"] = item.mainsStatus ? item.mainsTotal : "NA";
        }
          
        }
        if (this.chartIndex == 1) {
          baseObj["Screening Net Score"] = item.screeningStatus ? item.screeningTotal : "NA";
          baseObj["Mains Net Score"] = item.mainsStatus ? item.mainsTotal : "NA";
          baseObj["Demo Submitted On"] = item.demoSubmittedOn
            ? this.formatDate(new Date(item.demoSubmittedOn))
            : "NA";
          baseObj["Interview Scheduled"] = item.interviewScheduled || "NA";
          baseObj["Interview Scheduled On"] = item.interviewScheduledOn
            ? this.formatDate(new Date(item.interviewScheduledOn))
            : "NA";
          baseObj["Interviewers"] = item.interviewersEmail || "NA";
        }
 
        if (this.chartIndex === 2) {
          baseObj["Send To Hiring Manager On"] = item.sendToHiringManagerTime
            ? this.formatDate(new Date(item.sendToHiringManagerTime))
            : "NA";
          baseObj["Hiring Manager"] = item.hiringmanager || "NA";
          baseObj["Decision"] =
            this.getStatusInfo(item.filters.latestStatus).label || "NA";
        }
 
        if (this.chartIndex === 3) {
          baseObj["Offer Status"] =
            this.getStatusInfo(item.filters.latestStatus).label || "NA";
          baseObj["Final Decision Given By"] = item.hiringmanager || "NA";
        }
        if (this.chartIndex === 4) {
          baseObj["Action By Candidate"] = item.actionByCandidate || "NA";
          baseObj["Stage"] = this.getStatusInfo(item.stage).label || "NA";
        }
        if (this.chartIndex === 5) {
          baseObj["Final Interview Completed On"] =
            item.finalInterviewCompletedOn
              ? this.formatDate(new Date(item.finalInterviewCompletedOn))
              : "NA";
          baseObj["Sent to Hiring Manager On"] = item.sendToHiringManagerTime
            ? this.formatDate(new Date(item.sendToHiringManagerTime))
            : "NA";
          baseObj["Hiring Manager Decision"] =
            this.getStatusInfo(item.filters.latestStatus).label || "NA";
          baseObj["Decision Given On"] = this.calculateDaysDifference(
            item.decisionGivenOn,
            item.finalInterviewCompletedOn
          );
        }
 
        return baseObj;
      });
      this.downloadCSV(csvData, fileName);
    },
    async downloadCSV(csvData, fileName) {
      const csv = Papa.unparse(csvData);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      // this.loadingAssessmentsToDownload = false;
    },
    clearFilter() {
      this.selectedStatus = 'All'
      this.isApply = false;
      this.selectedGroupFilter = [];
      this.selectedJobRoleFilter = [];
      this.selectedSchoolFilter = [];
      this.selectedStageFilter = [];
      this.selectedStatusFilter = [];
      this.selectedReportedQuestionsFilter = null;
      this.getFilterCount();
      this.viewDashboard();
      this.getChartCount();
    },
    getFilterCount() {
      this.filterCount = [
        this.selectedGroupFilter,
        this.selectedJobRoleFilter,
        this.selectedSchoolFilter,
        this.selectedStageFilter,
        this.selectedStatusFilter,
      ].filter((filter) => filter?.length > 0).length;
    },

    getStatusInfo(status) {
      let label = status; // default label
      let color = "grey"; // default color
      let textColor = "white";
      switch (status) {
        case "SEND_TO_HIRING_MANAGER":
          if(this.chartIndex === 2) {
            label = "Pending with Hiring Manager";
            color = "#FFF4EB";
            textColor = "#FB7500";
          }
          else {
            label = "Scheduled";
            color = "#CBF0E0";
            textColor = "#007C2A";
          }

          break;
        case "DEMO SUBMITTED":
          label = "To Be Scheduled";
          color = "#FFF4EB";
          textColor = "#FB7500";

          break;
        case "INTERVIEW SCHEDULED":
        case "INTERVIEW RESCHEDULED":
          if(this.chartIndex === 2) {
            label = "Pending with Interviewer";
            color = "#CBF0E0";
            textColor = "#007C2A";
          }
          else {
          label = "Scheduled";
          color = "#CBF0E0";
          textColor = "#007C2A";
          }
          break;
        case "ACCEPT":
          if (this.chartIndex === 2) {
            label = "Decision Done by Hiring Manager";
            color = "#CBF0E0";
            textColor = "#007C2A";
          } else if (this.chartIndex === 3) {
            label = "Offered";
            color = "#CBF0E0";
            textColor = "#007C2A";
          } else if (this.chartIndex === 5) {
            label = "Accepted";
            color = "#CBF0E0";
            textColor = "#007C2A";
          }
          else {
          label = "Scheduled";
          color = "#CBF0E0";
          textColor = "#007C2A";
          } 
          break;
        case "REJECT":
          if (this.chartIndex === 2) {
            label = "Decision Done by Hiring Manager";
            color = "#CBF0E0";
            textColor = "#007C2A";
          } else if (this.chartIndex === 3) {
            label = "Not Offered";
            color = "#FFF4EB";
            textColor = "#FB7500";
          } else if (this.chartIndex === 5) {
            label = "Rejected";
            color = "#F9DBE1";
            textColor = "#D40028";
          }
          else {
          label = "Scheduled";
          color = "#CBF0E0";
          textColor = "#007C2A";
          }
          break;
        case "ONHOLD":
          if (this.chartIndex === 2) {
            label = "Decision Done by Hiring Manager";
            color = "#CBF0E0";
            textColor = "#007C2A";
          } else if (this.chartIndex === 3) {
            label = "Not Offered";
            color = "#FFF4EB";
            textColor = "#FB7500";
          } else if (this.chartIndex === 5) {
            label = "On Hold";
            color = "#FFF4EB";
            textColor = "#FB7500";
          }
          else {
          label = "Scheduled";
          color = "#CBF0E0";
          textColor = "#007C2A";
          }
          break;
        case "INTERVIEW COMPLETED":
          if(this.chartIndex === 2) {
          label = "Pending with HR";
          color = "#FBE1DD";
          textColor = "#CC7062";
          }
          else {
          label = "Scheduled";
          color = "#CBF0E0";
          textColor = "#007C2A";
          }
          break;
        case "NOTIFY_HR":
          label = "Scheduled";
          color = "#CBF0E0";
          textColor = "#007C2A";
          break;
        case "Now-Not Started":
          label = "Now-Not Started";
          color = "#CBF0E0";
          textColor = "#007C2A";
          break;
        case "Later":
          label = "Later";
          color = "#FFF4EB";
          textColor = "#FB7500";
          break;
        case "HR To Revert":
          label = "HR To Revert";
          color = "#E1E8F5";
          textColor = "#3F41D1";
          break;
        case "No Action":
          label = "No Action";
          color = "E0E0E0";
          textColor = "A3A3A3";
          break;
        case "INVITED":
          label = "Before Screening";
          break;
        case "SCREENING PASSED":
          label = "Before Mains";
          break;
        case "SCREENING FAILED":
          label = "Before Mains";
          break;
        case "MAINS PASSED":
          label = "Before Demo";
          break;
        case "MAINS FAILED":
          label = "Before Demo";
          break;
      }
      return { label, color, textColor };
    },
    async getSchool() {
      const response = await SchoolController.getSchool();
      if (response.status == 200) {
        const schoolData = response.data.schools;
        this.schoolList = schoolData
          .filter((school) => this.schools.includes(school.schoolCode))
          .map((school) => school.name);
          if(this.schools.includes('All')){
            // this.schoolList.unshift('All')
          }
      } else {
        alert("Schools Not Found!!");
      }
    },
    normalizeStatus(status) {
      // Convert status to camelCase to match `statusWiseCount` keys
      return status
        .toLowerCase()
        .replace(/[^a-zA-Z0-9 ]/g, "") // Remove special characters
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "");
    },
    formatStatus(status) {
      return status
        .replace(/([A-Z])/g, " $1") // camelCase → "camel Case"
        .replace(/_/g, " ") // snake_case → "snake case"
        .replace(/\b\w/g, (l) => l.toUpperCase()); // capitalize
    },
    changeChipStatus() {
      this.skipNextOptionWatch = this.options.page !== 1;
      this.options.page = 1;
      this.debouncedUserSearch();
    },
    toggleSelectedSchools(value) {
      // If currently "All", convert to all individual values and unselect this one
      if (this.selectedSchoolFilter.includes('All')) {
        this.selectedSchoolFilter = this.selectedSchoolFilter.filter((v) => v !== "All");
        this.selectedSchoolFilter = this.selectedSchoolFilter.filter((v) => v !== value);
        return
      }


      // Normal toggle
      if (this.selectedSchoolFilter.includes(value)) {
        this.selectedSchoolFilter = this.selectedSchoolFilter.filter((v) => v !== value)
      } else {
        this.selectedSchoolFilter.push(value)
      }

      // If all selectedSchoolFilter manually → switch back to "All"
      if (this.selectedSchoolFilter.length === this.schoolList.length) {
        this.selectedSchoolFilter = ["All",...this.schoolList]
      }
    },
    async getChartCount() {
        const statusList = this.getActualStatus("all");
        
        const field = "filters.latestStatus";

        let sortOrder = "asc";
        let sortBy = "";  // default empty, if no sorting

        if(this.isApply == false || this.selectedSchoolFilter.length <= 0){
            this.schoolList.forEach((school) => {
            if (!this.selectedSchoolFilter.includes(school)) {
              this.selectedSchoolFilter.push(school);
            }
            });
        }
        if(this.isApply == false ||this.selectedGroupFilter.length <= 0){
            this.groups.forEach((group) => {
            if (!this.selectedGroupFilter.includes(group)) {
              this.selectedGroupFilter.push(group);
            }
            });
        }

        const requestBody = {
          values: statusList,
          field: field,
          searchValue: this.search,
          groupFilter: this.selectedGroupFilter.includes('All') && this.selectedGroupFilter.length !== this.groups.length ? this.selectedGroupFilter.filter(v=>v != 'All') : this.selectedGroupFilter,
          schoolFilter: this.selectedSchoolFilter,
          jobRoleFilter: this.selectedJobRoleFilter,
          stageFilter: this.selectedStageFilter,
          statusFilter: this.selectedStatusFilter.includes('All') ? ['Pass','Fail'] : this.selectedStatusFilter,
          chartIndex: this.chartIndex,
          page: 1,
          sortOrder: sortOrder,
          sortBy: sortBy, 
          itemsPerPage: -1,
        };

        const response = await DashboardController.getChartCount(requestBody);
        this.totalCount = response.total;
        this.statusWiseCount = response.counts;
        if(this.chartIndex == 0 ){
          this.screeningPassCount = response.counts.screeningPassCount;
          this.screeningFailCount = response.counts.screeningFailCount;
          this.mainsPassCount = response.counts.mainsPassCount;
          this.mainsFailCount = response.counts.mainsFailCount;
        }
    }
  },
  watch: {
    // filterDialog(newValue){
    //   if(newValue == true){
    //     if(this.chartIndex == 4){
    //       this.selectedStatus = 'all'
    //     }
    //   }
    //   else{
    //     this.selectedStatus = this.selectedStatus;
    //   }
    // },
    search(newValue) {
      this.skipNextOptionWatch = this.options.page !== 1;
      this.options.page = 1;
      const urlParams = new URLSearchParams(
        window.location.hash.split("?")[1] || ""
      );
      const currentTab = urlParams.get("tab") || "all";

      // Update URL with tab first, then search
      const baseUrl = window.location.origin + "/#/view-chart-data";
      const tabParam = `tab=${currentTab}`;
      const searchParam = newValue
        ? `search=${encodeURIComponent(newValue)}`
        : "";
      const params = [tabParam, searchParam].filter(Boolean).join("&");
      const url = params ? `${baseUrl}?${params}` : baseUrl;
      window.history.pushState({}, "", url);

      if (this.search == null) {
        this.search = "";
      }
      this.debouncedUserSearch();
      this.debouncedChartCountSearch();
    },
  },
  computed: {
    filteredItems() {
    let schools = this.schoolList.filter((v) => v != "All");
    // Remove "All" from chip display
    if (schools.includes("All")) {
      schools = schools.filter(item => item !== "All");
    }
    if (!this.searchSchoolTerm) return schools;

    const term = this.searchSchoolTerm.toLowerCase();
    return schools.filter(item =>
      item.toLowerCase().includes(term)
    );
  },
  isAllSelected() {
      return (
        this.filteredItems.length > 0 &&
        this.filteredItems.every(item => this.selectedSchoolFilter.includes(item))
      );
  },
    filteredGroupItems() {
      let groups = this.groups;

      // Remove "All" for filtering purposes
      if (groups.includes("All")) {
        groups = groups.filter(item => item !== "All");
      }

      if (!this.searchGroupTerm) return groups;

      const term = this.searchGroupTerm.toLowerCase();
      return groups.filter(item =>
        item.toLowerCase().includes(term)
      );
    },
    filteredJobItems() {
      let preferredJobRoles = this.preferredJobRoles;
      
      // Remove "All" for filtering purposes
      if (preferredJobRoles.includes("All")) {
        preferredJobRoles = preferredJobRoles.filter(item => item !== "All");
      }

      if (!this.searchJobTerm) return preferredJobRoles;

      const term = this.searchJobTerm.toLowerCase();
      return preferredJobRoles.filter(item =>
        item.toLowerCase().includes(term)
      );
    },
    isAllGroupSelected() {
      return (
        this.filteredGroupItems.length > 0 &&
        this.filteredGroupItems.every(item => this.selectedGroupFilter.includes(item))
      );
    },
    isAllJobSelected() {
      return (
        this.filteredJobItems.length > 0 &&
        this.filteredJobItems.every(item => this.selectedJobRoleFilter.includes(item))
      );
    },
    formattedStatuses() {
      return this.statuses.map((status) => {
        const key = this.normalizeStatus(status);
          return {
          key: key,
          label: key === 'nownotStarted' ? 'Now-Not Started' : key === 'hrToRevert' ? 'HR to Revert' : this.formatStatus(key),
          count: key == "all" ? this.count : this.statusWiseCount?.[key] || 0,
        };
      });
    },

    visibleSchools() {
      if (this.schools.includes("All")) {
        return ["All"];
      }
      return this.schoolList.slice(0, 5);
    },
    hiddenSchools() {
      if (this.schools.includes("All")) {
        return [];
      }
      return this.schoolList.slice(5);
    },
    remainingCount() {
      if (this.schools.includes("All")) {
        return 0;
      }
      return this.schoolList.length > 5 ? this.schoolList.length - 5 : 0;
    },
    displayGroups() {
      return this.groups.includes("All") ? "All" : this.groups.join(", ");
    },
    tableHeaders() {
      const baseHeaders = [
        {
          text: "Candidate Name",
          value: "fullName",
          cellClass: "w-15",
          sortable: true,
        },
        {
          text: "Email ID",
          value: "emailId",
          cellClass: "w-15 text-lowercase",
          sortable: true,
        },
        {
          text: "School",
          value: "school",
          cellClass: this.chartIndex == 1 ? "w-20" : "w-15",
          sortable: true,
        },
        {
          text: "Preferred Job Role",
          value: "jobRole",
          cellClass: this.chartIndex == 1 || this.chartIndex == 3 ? "w-40" : "w-30",
          sortable: true,
        },
      ];

      // Conditionally add more headers based on chartIndex
      if (this.chartIndex === 0) {
        if(this.selectedStatus == 'screening'){
          baseHeaders.push(
          {
            text: "Screening Score",
            value: "screeningTotal",
            cellClass: "w-20",
            sortable: true,
          }
        );

        }
        else if(this.selectedStatus == 'mains'){
          baseHeaders.push(
          {
            text: "Mains Score",
            value: "mainsTotal",
            cellClass: "w-20",
            sortable: true,
          }
        );

        }else{
          baseHeaders.push(
          {
            text: "Screening Score",
            value: "screeningTotal",
            cellClass: "w-10",
            sortable: true,
          },
          {
            text: "Mains Score",
            value: "mainsTotal",
            cellClass: "w-10",
            sortable: true,
          }
        );
        }
        
      }
      if (this.chartIndex === 1) {
        baseHeaders.push({
          text: "Interview Status",
          value: "status",
          cellClass: "w-15",
          sortable: false,
        });
      }

      if (this.chartIndex === 2) {
        baseHeaders.push(
          {
            text: "Hiring Manager",
            value: "hiringmanager",
            cellClass: "w-15",
            sortable: true,
          },
          {
            text: "Status",
            value: "status",
            cellClass: "w-20",
            sortable: false,
          }
        );
      }
      if (this.chartIndex === 3) {
        baseHeaders.push({
          text: "Offer Status",
          value: "status",
          cellClass: "w-15",
          sortable: false,
        });
      }
      if (this.chartIndex === 4) {
        baseHeaders.push(
          {
            text: "Stage",
            value: "stage",
            cellClass: "w-10",
            sortable: true,
          },
          {
            text: "Action by Candidate",
            value: "actionByCandidate",
            cellClass: "w-15",
            sortable: false,
          }
        );
      }

      if (this.chartIndex === 5) {
        baseHeaders.push(
          {
            text: "Avg. Time to Close Application",
            value: "daysToCloseApplication",
            cellClass: "w-15",
            sortable: true,
          },
          {
            text: "Status",
            value: "status",
            cellClass: "w-10",
            sortable: false,
          }
        );
      }
      return baseHeaders;
    },
  },
  mounted() {
  },
  unmounted() {
    this.debouncedUserSearch.cancel();
  },
  created() {
    const incomingStatus = JSON.parse(this.$route.query.status || "[]");
    this.schools = JSON.parse(this.$route.query.schools || "[]");
    this.groups = JSON.parse(this.$route.query.groups || "[]");
    // this.groups = this.groups.filter(group => group != 'All');
    this.chartIndex = JSON.parse(this.$route.query.chartIndex);
    this.statuses.push(...incomingStatus);
    this.getSchool();
    this.debouncedUserSearch = debounce(this.viewDashboard, 500);
    this.debouncedChartCountSearch = debounce(this.getChartCount, 500);
    this.debouncedChartCountSearch();
    this.viewDashboard();
  },
};
</script>
<style>
.header-card {
  border: 1px grey;
  border-radius: 15px;
  padding: 10px;
  margin-bottom: 10px;
  background-color: white;
}
.dark-text {
  color: #333 !important;
}
.scheduled {
  color: #007c2a !important;
}
.tab-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%; /* ensures the span goes full width inside the tab */
}
.status-count-badge {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #e697ab;
  display: flex;
  justify-content: center;
  align-items: center;
}
.status-count-badge p {
  font-size: 10px;
  margin: 0;
  line-height: 1;
  color: black; /* Optional: for better contrast */
}
.light-border {
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 4px;
}
.label {
  font-size: 14px;
  font-weight: 400;
}
.value {
  font-size: 14px;
  font-weight: 500;
  font-family: "GraphikMedium";
}
.chartHeader {
  font-size: 20px;
  font-weight: 500;
  font-family: "GraphikMedium";
}

.breadcrumb-previous-text {
  text-decoration: none;
  color: #00000099 !important;
  font-size: 0.875rem;
  font-weight: 400 !important;
  font-family: "GraphikRegular", sans-serif !important;
}
.active-chip {
  color: var(--blue-01) !important;
  background: var(--gray-02) !important;
  border: 1px solid var(--blue-01) !important;
  font-weight: 400 !important;
}
/* Hide default Vuetify sort icon */
.usertable .v-data-table-header__icon {
  display: none !important;
  
}
.usertable .v-data-table__wrapper {
  overflow: auto !important; /* enable scrolling */
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE/old Edge */
}

.usertable .v-data-table__wrapper::-webkit-scrollbar {
  display: none !important; /* Chrome, Safari, new Edge */
}

/* Header content layout */
.header-content {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Hide default Vuetify sort icon */
.usertable .v-data-table-header__icon {
  display: none !important;
}


/* Sort icon wrapper - always visible */
.sort-icon-wrapper {
  display: inline-flex;
  align-items: center;
  opacity: 1;
}

/* SVG/Image styling */
.sort-icon {
  display: block;
  width: 16px;
  height: 16px;
}
.truncate-cell {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block; /* or inline-block */
  cursor: default;
}
.multi-line-ellipsis{
  display: -webkit-box;
  -webkit-line-clamp: 1; 
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: auto;
  /* max-width: 140px; */
}
.disabled-btn {
  opacity: 0.5;
  border-color: #ccc !important;
  pointer-events: none;
}


</style>
